import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReportsComponent} from './reports.component';
import { Routes, RouterModule } from '@angular/router';
import { Route } from '@app/core/route.service';

const routes: Routes = Route.withShell([
  { path: 'reports', component: ReportsComponent, data: { title: 'Reports' } }
]);

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[RouterModule],
  declarations: []
})
export class ReportsRouteModule { }
